import type { RequestStartedEvent } from '#api/apiListeners'
import { store } from '#app/store'

const matchConfigurationModification = /\/api\/configuration\/([^/]+)\//s

export function collectMetadataForRequest(request: RequestStartedEvent): Record<string, unknown> | undefined {
  try {
    const uuidMatch = request.url.match(matchConfigurationModification)
    if (uuidMatch?.[1]) {
      const uuid = uuidMatch[1]
      if (uuid) {
        const configs = store.getState().truckConfigurations.configurations
        const configuration = Object.values(configs).find((config) => config?.uuid === uuid)
        if (configuration) {
          return {
            ...configuration.apiConfiguration,
          }
        }
      }
    }
  } catch (error) {
    console.error('Error collecting metadata for request', request, error)
  }

  return undefined
}
